import { defineMessages } from 'react-intl'

export const paymentsMessages = defineMessages({
  upgradeAccount: {
    id: 'paymentsMessages.upgradeAccount',
    defaultMessage: 'Upgrade Your Account'
  },
  monthlyBilling: {
    id: 'paymentsMessages.monthlyBilling',
    defaultMessage: 'Monthly Billing'
  }
})
